import {axios} from '../../services/axios';

export default function getAppAuthByID(id) {
    return axios.get(`/appauth/${id}`);
}
